import cn from "classnames";
import { useEffect, useState } from "react";
import { CheckboxTreeProps, FullNode } from "./types";
import { CheckboxTreeItem } from "./checkbox-tree-item";
import {
  completeDisabledNodesListWithNestedValues,
  updateCheckedNodes,
} from "./utils";
import styles from "./styles.module.scss";

export const CheckboxTree = ({
  nodes,
  checkedNodes = [],
  expandedNodes,
  disabledNodes: disabledNodesFromProps,
  className,
  dataTestId = "checkbox-tree",
  onChange,
}: CheckboxTreeProps) => {
  const [disabledNodes, setDisabledNodes] = useState(disabledNodesFromProps);

  useEffect(() => {
    const completedDisabledNodes = completeDisabledNodesListWithNestedValues(
      nodes,
      disabledNodesFromProps
    );

    setDisabledNodes(completedDisabledNodes);
  }, [disabledNodesFromProps, nodes]);

  const handleChange = (changedNodes: string[], node: FullNode) => {
    const newCheckedNodes = updateCheckedNodes(
      checkedNodes,
      changedNodes,
      node.checked,
      disabledNodes
    );

    onChange?.(newCheckedNodes, node);
  };

  return (
    <div className={cn(className, styles.container)} data-test-id={dataTestId}>
      {nodes?.map(({ label, value, nodes: childrenNodes }) => (
        <CheckboxTreeItem
          key={value}
          label={label}
          value={value}
          nodes={childrenNodes}
          disabledNodes={disabledNodes}
          checkedNodes={checkedNodes}
          expandedNodes={expandedNodes}
          dataTestId={`${dataTestId}-item`}
          onChange={handleChange}
        />
      ))}
    </div>
  );
};
